import { useContext } from "react";
import { AuthContext } from "@/context/AuthContext"; // caminho correto com alias

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve ser usado dentro de um AuthProvider");
  }
  return context;
};
